import { regexOnlyNumber } from "../../constants/RegexpConstants";

export function formatPhoneNumber(phone: string): string {
  // Убираем все нецифровые символы
  let cleaned = phone.replace(regexOnlyNumber, "");

  // Проверяем, начинается ли номер с 8, если да — заменяем на 7
  if (cleaned.startsWith("8")) cleaned = "7" + cleaned.slice(1);

  // Если номер начинается не с 7, добавляем 7 в начало
  if (!cleaned.startsWith("7")) cleaned = "7" + cleaned;

  // Дополняем номер до 11 символов, если не хватает, заполняем _
  cleaned = cleaned.padEnd(11, "_");

  return `+7 ${cleaned.slice(1, 4)} ${cleaned.slice(4, 7)} ${cleaned.slice(7, 9)} ${cleaned.slice(9, 11)}`;
}

export function formatPhoneNumberEightStart(input: string): string {
  // Оставляем только цифры
  const digits = input.replace(regexOnlyNumber, "");

  // Проверяем, что номер российский и имеет 10 или 11 цифр
  const match = digits.match(/^(\+7|7|8)?(\d{10})$/);

  if (!match) {
    return input; // Если не подходит под формат — возвращаем как есть
  }

  const phone = match[2]; // 10 цифр номера без кода страны

  // Форматируем в нужный вид: 8 (XXX) XXX XX XX
  return `8 (${phone.slice(0, 3)}) ${phone.slice(3, 6)} ${phone.slice(6, 8)} ${phone.slice(8, 10)}`;
}
